import type { WebhooksUpdateContent } from './Definitions/Types';
import type { WebhooksDataAPI } from './Definitions/WebhookTypes';

export const webhooksTransformer = (response: WebhooksDataAPI): WebhooksUpdateContent[] => {
  return response.data.map((webhooks) => ({
    id: webhooks.id,
    name: webhooks.name,
    url: webhooks.url,
    eventTypes: webhooks.event_types,
    secretKey: webhooks.secret_key,
    customHeaders: webhooks.custom_headers,
    createdAt: webhooks.created_at,
    updatedAt: webhooks.updated_at,
    active: webhooks.active,
    failureStartedAt: webhooks.failure_started_at,
    failureAttempts: webhooks.failure_attempts,
    failureReason: webhooks.failure_reason,
    deactivatedAt: webhooks.deactivated_at,
  }));
};

export const translateEventName = (eventName: string): string => {
  const keyMap: Record<string, string> = {
    ignition_on: 'webhooks.events.ignition_on',
    ignition_off: 'webhooks.events.ignition_off',
    position: 'webhooks.events.position',
    position_sleep: 'webhooks.events.position_sleep',
    geofence_in: 'webhooks.events.geofence_in',
    geofence_out: 'webhooks.events.geofence_out',
    speed: 'webhooks.events.speed',
    battery_external_low: 'webhooks.events.battery_external_low',
    battery_external_disconnected: 'webhooks.events.battery_external_disconnected',
    battery_external_reconnected: 'webhooks.events.battery_external_reconnected',
  };
  return keyMap[eventName] ?? 'webhooks.events.unknown';
};

export const translateErrorMessage = (errorMessage: string): string => {
  if (errorMessage.indexOf('500') > -1) return 'webhooks.errors.500';
  if (errorMessage.indexOf('503') > -1) return 'webhooks.errors.503';
  if (errorMessage.indexOf('504') > -1) return 'webhooks.errors.504';
  if (errorMessage.indexOf('400') > -1) return 'webhooks.errors.400';
  if (errorMessage.indexOf('403') > -1) return 'webhooks.errors.403';
  return 'webhooks.errors.unknown';
};
